/*
  Stellar (Oct 2026): sends sign-ups to Klaviyo "Newsletter Sign Up" (list
  VMp4WE), the pop-up's list, which runs the welcome flow. Patrick and Break
  Thirty (Ryan, Oct 16): footer and pop-up sign-ups should feed one list.

  - Footer "Stay Informed" form (Patrick's custom footer): still submits to
    Shopify exactly as before; this subscribes the email to VMp4WE first.
  - Coming-soon waitlist (snippets/bremoir-atc.liquid): calls
    stellarKlaviyoSubscribe with a Waitlist property, so launch day can email
    that segment.
*/
(function () {
  var COMPANY = 'SM8SZL'; // public site key, the same one klaviyo.js loads with
  var LIST = 'VMp4WE';    // "Newsletter Sign Up"

  function subscribe(opts) {
    var profile = { email: opts.email };
    if (opts.firstName) profile.first_name = opts.firstName;
    if (opts.properties) profile.properties = opts.properties;
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + COMPANY, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: opts.source,
            profile: { data: { type: 'profile', attributes: profile } }
          },
          relationships: { list: { data: { type: 'list', id: LIST } } }
        }
      })
    });
  }
  window.stellarKlaviyoSubscribe = subscribe;

  // Footer form: hold the Shopify submit until Klaviyo answers (2.5s at most),
  // then submit natively, which posts to Shopify the same way it always has.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest || !form.closest('.brem-footer')) return;
    var email = form.querySelector('input[name="contact[email]"]');
    if (!email || !email.value) return;
    e.preventDefault();
    var sent = false;
    function proceed() {
      if (sent) return;
      sent = true;
      HTMLFormElement.prototype.submit.call(form);
    }
    setTimeout(proceed, 2500);
    subscribe({ email: email.value.trim(), source: 'Footer newsletter form' })
      .then(proceed, proceed);
  }, true);
})();
